// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"98393f3b","787":"0e029a22","964":"bd2fba74"}[chunkId] + ".chunk.js";
};